import { useEffect, useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { useForgotPassword } from '@/api/api-hooks/auth-hooks';
import Popup from '@/components/elements/Popup';
import { LabelInput } from '@/components/forms/LabelInput';
import AppButton from '@/components/ui/Button';

interface Inputs {
  email: string;
}

function ForgotPassForm({ closeForm }: { closeForm: () => void }) {
  const [openPopup, setOpenPopup] = useState<boolean>(false);
  const [title, setTitle] = useState<string>('');

  const { mutate: forgotPasswordRequest, isPending, data, isSuccess } = useForgotPassword();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>({
    mode: 'onChange',
  });
  const onSubmit: SubmitHandler<Inputs> = (data) => {
    forgotPasswordRequest({
      email: data.email,
    });
  };

  useEffect(() => {
    if (data && isSuccess) {
      if (data?.error) {
        setTitle('Error!');
      } else {
        setTitle('Success!');
        reset();
      }
      setOpenPopup(true);
    }
  }, [data, isSuccess]);

  return (
    <>
      <div className="h-full">
        <form onSubmit={handleSubmit(onSubmit)} className="h-full">
          <div className="flex h-[calc(100%-80px)] w-full flex-col justify-between">
            <div className="p-4 md:p-6">
              <LabelInput
                name="email"
                labelText="Email"
                placeholder="Enter your email"
                id="email"
                otherProps={{
                  ...register('email', {
                    required: 'Email is required',
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: 'Email is not correct',
                    },
                    maxLength: { value: 320, message: 'Too long email' },
                  }),
                  ...{ maxLength: 320 },
                }}
                error={errors.email?.message}
              />
            </div>
            <div className="flex w-full items-center justify-end p-5">
              <AppButton onClick={closeForm} variant="secondary" className="mr-4">
                Cancel
              </AppButton>
              <AppButton disabled={isPending} type="submit" loading={isPending}>
                Send request
              </AppButton>
            </div>
          </div>
        </form>
      </div>
      <Popup isOpen={openPopup} onClose={() => setOpenPopup(false)} title={title}>
        <p>{data?.message}</p>
      </Popup>
    </>
  );
}

export default ForgotPassForm;
